module.exports = __webpack_public_path__ + "img/wallet-icon.721e2e65.svg";